import React, { useEffect, useState } from 'react';
import { getApiBaseUrl } from '../../utils/apiConfig';
import { cookieManager } from '../../utils/cookieManager';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Footer from './Footer';

const API = getApiBaseUrl();

const PointsCenter = () => {
  const [wallet, setWallet] = useState(null);
  const [ledger, setLedger] = useState({ total: 0, items: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const fetchAll = async () => {
    setLoading(true);
    setError('');
    try {
      const [wRes, lRes] = await Promise.all([
        fetch(`${API}/points/wallet`, { credentials: 'include' }),
        fetch(`${API}/points/ledger?skip=0&limit=50`, { credentials: 'include' })
      ]);
      const wJson = await wRes.json();
      const lJson = await lRes.json();
      if (!wRes.ok) throw new Error(wJson.detail || '获取钱包失败');
      if (!lRes.ok) throw new Error(lJson.detail || '获取明细失败');
      setWallet(wJson);
      setLedger(lJson);
    } catch (e) {
      setError(e.message || '加载失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchAll(); }, []);

  const username = cookieManager.getUserEmail() || '用户';

  return (
    <>
      <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-3xl mx-auto">
        <div className="mb-6 flex items-center space-x-4">
          <button
            onClick={() => navigate('/home')}
            className="inline-flex items-center px-4 py-2 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded transition-colors"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            返回个人中心
          </button>
          <div>
            <h1 className="text-2xl font-bold text-gray-800">积分中心</h1>
            <p className="text-sm text-gray-500 mt-1">欢迎，{username}</p>
          </div>
        </div>

        {loading && (
          <div className="p-4 bg-white rounded-lg shadow">加载中...</div>
        )}

        {error && (
          <div className="p-4 bg-red-50 border border-red-200 text-red-700 rounded-lg shadow">{error}</div>
        )}

        {wallet && (
          <div className="p-5 bg-white rounded-lg shadow mb-6 border">
            <div className="text-gray-600 text-sm">当前积分</div>
            <div className="text-4xl font-extrabold text-emerald-600 mt-1">{wallet.balance}</div>
            <div className="text-xs text-gray-400 mt-2">最近更新：{new Date(wallet.updated_at).toLocaleString()}</div>
            <div className="mt-3">
              <button
                onClick={() => navigate('/recharge')}
                className="w-full px-4 py-2 rounded bg-emerald-600 text-white hover:bg-emerald-700 transition-colors font-medium"
              >
                💰 立即充值
              </button>
            </div>
          </div>
        )}

        <div className="bg-white rounded-lg shadow border">
          <div className="px-5 py-3 border-b bg-gray-50 font-medium text-gray-700">积分明细（最近50条）</div>
          <div className="divide-y">
            {ledger.items.length === 0 && (
              <div className="p-5 text-gray-500 text-sm">暂无记录</div>
            )}
            {ledger.items.map((it) => (
              <div key={it._id} className="px-5 py-3 grid grid-cols-12 items-center text-sm">
                <div className="col-span-2 font-mono text-gray-500">{(it.delta > 0 ? '+' : '') + it.delta}</div>
                <div className="col-span-4 text-gray-700">{it.reason}</div>
                <div className="col-span-4 text-gray-400">{it.ref_id || '-'}</div>
                <div className="col-span-2 text-right text-gray-400">{new Date(it.created_at).toLocaleString()}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
      <Footer variant="simple" showCopyright={false} />
    </>
  );
};

export default PointsCenter;
